// This file is needed because React Native does not support dynamic requires. It is generated when starting the packager via yarn start or when bundling with gulp (either locally or for Jenkins).\n
// This file was last generated on Thu Aug 20 23:11:59 UTC 2026. Do not modify it directly.\n
export default {
  ['Apple_Pay_Mark.svg']: require('./Apple_Pay_Mark.svg').default,
  ['LTOClockHands.svg']: require('./LTOClockHands.svg').default,
  ['ach_bank_icon.svg']: require('./ach_bank_icon.svg').default,
  ['ach_link_successful_checkmark.svg']: require('./ach_link_successful_checkmark.svg').default,
  ['apple.svg']: require('./apple.svg').default,
  ['apple_auth.svg']: require('./apple_auth.svg').default,
  ['apple_white.svg']: require('./apple_white.svg').default,
  ['arrow-left_black.svg']: require('./arrow-left_black.svg').default,
  ['arrow.svg']: require('./arrow.svg').default,
  ['arrow_down.svg']: require('./arrow_down.svg').default,
  ['arrow_left.svg']: require('./arrow_left.svg').default,
  ['arrow_right.svg']: require('./arrow_right.svg').default,
  ['avatar_rays.svg']: require('./avatar_rays.svg').default,
  ['background.svg']: require('./background.svg').default,
  ['background_tablet.svg']: require('./background_tablet.svg').default,
  ['bank_icon.svg']: require('./bank_icon.svg').default,
  ['bank_icon_blue.svg']: require('./bank_icon_blue.svg').default,
  ['bank_icon_list.svg']: require('./bank_icon_list.svg').default,
  ['bank_preferred_icon.svg']: require('./bank_preferred_icon.svg').default,
  ['banner_limited_use_template.svg']: require('./banner_limited_use_template.svg').default,
  ['blue_check_icon.svg']: require('./blue_check_icon.svg').default,
  ['bracketIcon.svg']: require('./bracketIcon.svg').default,
  ['bracket_crown.svg']: require('./bracket_crown.svg').default,
  ['cash_icon.svg']: require('./cash_icon.svg').default,
  ['check_icon.svg']: require('./check_icon.svg').default,
  ['check_mark.svg']: require('./check_mark.svg').default,
  ['checkmark.svg']: require('./checkmark.svg').default,
  ['chevron_right.svg']: require('./chevron_right.svg').default,
  ['claimed_frame.svg']: require('./claimed_frame.svg').default,
  ['clock.svg']: require('./clock.svg').default,
  ['close.svg']: require('./close.svg').default,
  ['close_button_icon.svg']: require('./close_button_icon.svg').default,
  ['close_white.svg']: require('./close_white.svg').default,
  ['countdown_background_1.svg']: require('./countdown_background_1.svg').default,
  ['countdown_background_2.svg']: require('./countdown_background_2.svg').default,
  ['cross_modal.svg']: require('./cross_modal.svg').default,
  ['customer_support.svg']: require('./customer_support.svg').default,
  ['darkWarning.svg']: require('./darkWarning.svg').default,
  ['deco_bonus_cash.svg']: require('./deco_bonus_cash.svg').default,
  ['deco_calendar_glow.svg']: require('./deco_calendar_glow.svg').default,
  ['deco_checkout_amex.svg']: require('./deco_checkout_amex.svg').default,
  ['deco_checkout_applepaycard.svg']: require('./deco_checkout_applepaycard.svg').default,
  ['deco_checkout_applepaylogo.svg']: require('./deco_checkout_applepaylogo.svg').default,
  ['deco_checkout_camera.svg']: require('./deco_checkout_camera.svg').default,
  ['deco_checkout_checkmark_box.svg']: require('./deco_checkout_checkmark_box.svg').default,
  ['deco_checkout_checkmark_filled.svg']: require('./deco_checkout_checkmark_filled.svg').default,
  ['deco_checkout_creditcard.svg']: require('./deco_checkout_creditcard.svg').default,
  ['deco_checkout_discover.svg']: require('./deco_checkout_discover.svg').default,
  ['deco_checkout_mastercard.svg']: require('./deco_checkout_mastercard.svg').default,
  ['deco_checkout_paypal.svg']: require('./deco_checkout_paypal.svg').default,
  ['deco_checkout_questionmark.svg']: require('./deco_checkout_questionmark.svg').default,
  ['deco_checkout_successcheckmark.svg']: require('./deco_checkout_successcheckmark.svg').default,
  ['deco_checkout_trash.svg']: require('./deco_checkout_trash.svg').default,
  ['deco_checkout_venmo.svg']: require('./deco_checkout_venmo.svg').default,
  ['deco_checkout_visa.svg']: require('./deco_checkout_visa.svg').default,
  ['deco_day_7_glow.svg']: require('./deco_day_7_glow.svg').default,
  ['deco_giftbox.svg']: require('./deco_giftbox.svg').default,
  ['deco_hosted_sheen.svg']: require('./deco_hosted_sheen.svg').default,
  ['deco_label_shadow.svg']: require('./deco_label_shadow.svg').default,
  ['deco_logo_skillzpowered.svg']: require('./deco_logo_skillzpowered.svg').default,
  ['deco_logo_skillzpowered_balance_bar.svg']: require('./deco_logo_skillzpowered_balance_bar.svg').default,
  ['deco_paypal_dark.svg']: require('./deco_paypal_dark.svg').default,
  ['deco_paypal_light.svg']: require('./deco_paypal_light.svg').default,
  ['deco_profile_leagues_place_container.svg']: require('./deco_profile_leagues_place_container.svg').default,
  ['deco_referral_gift_confetti.svg']: require('./deco_referral_gift_confetti.svg').default,
  ['deco_rewardCalendar_confetti.svg']: require('./deco_rewardCalendar_confetti.svg').default,
  ['deco_reward_calendar_starburst.svg']: require('./deco_reward_calendar_starburst.svg').default,
  ['deco_three_giftboxes.svg']: require('./deco_three_giftboxes.svg').default,
  ['deco_ticketz_benefit_multiplier.svg']: require('./deco_ticketz_benefit_multiplier.svg').default,
  ['deco_ticketz_benefit_support.svg']: require('./deco_ticketz_benefit_support.svg').default,
  ['deposit.svg']: require('./deposit.svg').default,
  ['deposit_details_info_icon.svg']: require('./deposit_details_info_icon.svg').default,
  ['deposit_offer_custom_label_gold.svg']: require('./deposit_offer_custom_label_gold.svg').default,
  ['deposit_offer_custom_label_pink.svg']: require('./deposit_offer_custom_label_pink.svg').default,
  ['discount_bg_image.svg']: require('./discount_bg_image.svg').default,
  ['dollar_coin.svg']: require('./dollar_coin.svg').default,
  ['edit_pencil.svg']: require('./edit_pencil.svg').default,
  ['ellipse.svg']: require('./ellipse.svg').default,
  ['email_nudge_cross.svg']: require('./email_nudge_cross.svg').default,
  ['error_info.svg']: require('./error_info.svg').default,
  ['eye-off.svg']: require('./eye-off.svg').default,
  ['facebook.svg']: require('./facebook.svg').default,
  ['fairplay_footer.svg']: require('./fairplay_footer.svg').default,
  ['fairplay_footer_light_theme.svg']: require('./fairplay_footer_light_theme.svg').default,
  ['fast_and_direct_banking.svg']: require('./fast_and_direct_banking.svg').default,
  ['fast_match_stakes_deselect_button.svg']: require('./fast_match_stakes_deselect_button.svg').default,
  ['floating_dollar.svg']: require('./floating_dollar.svg').default,
  ['footer_bump.svg']: require('./footer_bump.svg').default,
  ['g_calendar.svg']: require('./g_calendar.svg').default,
  ['game_crash.svg']: require('./game_crash.svg').default,
  ['get_bonus.svg']: require('./get_bonus.svg').default,
  ['goldClock.svg']: require('./goldClock.svg').default,
  ['google.svg']: require('./google.svg').default,
  ['gray_frame.svg']: require('./gray_frame.svg').default,
  ['greatJob.svg']: require('./greatJob.svg').default,
  ['green_check_mark.svg']: require('./green_check_mark.svg').default,
  ['green_frame.svg']: require('./green_frame.svg').default,
  ['help-circle_black.svg']: require('./help-circle_black.svg').default,
  ['helpIcon.svg']: require('./helpIcon.svg').default,
  ['help_circle.svg']: require('./help_circle.svg').default,
  ['ic_XButton_black.svg']: require('./ic_XButton_black.svg').default,
  ['ic_add_cash.svg']: require('./ic_add_cash.svg').default,
  ['ic_arrow_down_caret_skz.svg']: require('./ic_arrow_down_caret_skz.svg').default,
  ['ic_arrow_drop_down.svg']: require('./ic_arrow_drop_down.svg').default,
  ['ic_arrow_new_disabled.svg']: require('./ic_arrow_new_disabled.svg').default,
  ['ic_arrow_new_green.svg']: require('./ic_arrow_new_green.svg').default,
  ['ic_calendar.svg']: require('./ic_calendar.svg').default,
  ['ic_camera.svg']: require('./ic_camera.svg').default,
  ['ic_chat_side_menu.svg']: require('./ic_chat_side_menu.svg').default,
  ['ic_check_green_paid_leagues.svg']: require('./ic_check_green_paid_leagues.svg').default,
  ['ic_close_button.svg']: require('./ic_close_button.svg').default,
  ['ic_close_results.svg']: require('./ic_close_results.svg').default,
  ['ic_diagonal_top_left_to_bottom_right.svg']: require('./ic_diagonal_top_left_to_bottom_right.svg').default,
  ['ic_edit_button.svg']: require('./ic_edit_button.svg').default,
  ['ic_edit_button_rounded.svg']: require('./ic_edit_button_rounded.svg').default,
  ['ic_league_rank_1.svg']: require('./ic_league_rank_1.svg').default,
  ['ic_league_rank_2.svg']: require('./ic_league_rank_2.svg').default,
  ['ic_league_rank_3.svg']: require('./ic_league_rank_3.svg').default,
  ['ic_leagues_medals_summary_info.svg']: require('./ic_leagues_medals_summary_info.svg').default,
  ['ic_lock.svg']: require('./ic_lock.svg').default,
  ['ic_nav_close.svg']: require('./ic_nav_close.svg').default,
  ['ic_new_logo_skillz.svg']: require('./ic_new_logo_skillz.svg').default,
  ['ic_new_tooltip.svg']: require('./ic_new_tooltip.svg').default,
  ['ic_new_tooltip_circle.svg']: require('./ic_new_tooltip_circle.svg').default,
  ['ic_new_tooltip_i.svg']: require('./ic_new_tooltip_i.svg').default,
  ['ic_new_wallet.svg']: require('./ic_new_wallet.svg').default,
  ['ic_new_wallet_v2.svg']: require('./ic_new_wallet_v2.svg').default,
  ['ic_notification_bell.svg']: require('./ic_notification_bell.svg').default,
  ['ic_person.svg']: require('./ic_person.svg').default,
  ['ic_play_button.svg']: require('./ic_play_button.svg').default,
  ['ic_player_icon_instamatch.svg']: require('./ic_player_icon_instamatch.svg').default,
  ['ic_player_icon_skz_v2.svg']: require('./ic_player_icon_skz_v2.svg').default,
  ['ic_random_button.svg']: require('./ic_random_button.svg').default,
  ['ic_refresh.svg']: require('./ic_refresh.svg').default,
  ['ic_skillz_horizontal_lockup.svg']: require('./ic_skillz_horizontal_lockup.svg').default,
  ['ic_skillz_logo_with_bars.svg']: require('./ic_skillz_logo_with_bars.svg').default,
  ['ic_skillz_mark_with_bars.svg']: require('./ic_skillz_mark_with_bars.svg').default,
  ['ic_skillz_s.svg']: require('./ic_skillz_s.svg').default,
  ['ic_social_chat.svg']: require('./ic_social_chat.svg').default,
  ['ic_spectate.svg']: require('./ic_spectate.svg').default,
  ['ic_zcash_new.svg']: require('./ic_zcash_new.svg').default,
  ['icon_arrow_clockwise_circle.svg']: require('./icon_arrow_clockwise_circle.svg').default,
  ['icon_arrow_right.svg']: require('./icon_arrow_right.svg').default,
  ['icon_avatar_add.svg']: require('./icon_avatar_add.svg').default,
  ['icon_bank_logos.svg']: require('./icon_bank_logos.svg').default,
  ['icon_bank_withdrawal_success.svg']: require('./icon_bank_withdrawal_success.svg').default,
  ['icon_chat_accept_friend.svg']: require('./icon_chat_accept_friend.svg').default,
  ['icon_chat_add_friend.svg']: require('./icon_chat_add_friend.svg').default,
  ['icon_chat_blocked.svg']: require('./icon_chat_blocked.svg').default,
  ['icon_chat_header_dark.svg']: require('./icon_chat_header_dark.svg').default,
  ['icon_chat_header_light.svg']: require('./icon_chat_header_light.svg').default,
  ['icon_chat_mute.svg']: require('./icon_chat_mute.svg').default,
  ['icon_chat_new_message.svg']: require('./icon_chat_new_message.svg').default,
  ['icon_chat_reject_friend.svg']: require('./icon_chat_reject_friend.svg').default,
  ['icon_chat_request_sent.svg']: require('./icon_chat_request_sent.svg').default,
  ['icon_chat_search.svg']: require('./icon_chat_search.svg').default,
  ['icon_checkmark.svg']: require('./icon_checkmark.svg').default,
  ['icon_checkmark_circle.svg']: require('./icon_checkmark_circle.svg').default,
  ['icon_circle_checkmark.svg']: require('./icon_circle_checkmark.svg').default,
  ['icon_circle_x.svg']: require('./icon_circle_x.svg').default,
  ['icon_clock_circle.svg']: require('./icon_clock_circle.svg').default,
  ['icon_close_modal.svg']: require('./icon_close_modal.svg').default,
  ['icon_custom_prize.svg']: require('./icon_custom_prize.svg').default,
  ['icon_deposit_check.svg']: require('./icon_deposit_check.svg').default,
  ['icon_deposit_success_check_mark.svg']: require('./icon_deposit_success_check_mark.svg').default,
  ['icon_down_arrow.svg']: require('./icon_down_arrow.svg').default,
  ['icon_earn_calendar.svg']: require('./icon_earn_calendar.svg').default,
  ['icon_earn_prizes.svg']: require('./icon_earn_prizes.svg').default,
  ['icon_earn_tier.svg']: require('./icon_earn_tier.svg').default,
  ['icon_footer_home.svg']: require('./icon_footer_home.svg').default,
  ['icon_footer_home_tungsten.svg']: require('./icon_footer_home_tungsten.svg').default,
  ['icon_footer_leagues.svg']: require('./icon_footer_leagues.svg').default,
  ['icon_footer_leagues_tungsten.svg']: require('./icon_footer_leagues_tungsten.svg').default,
  ['icon_footer_menu_tungsten.svg']: require('./icon_footer_menu_tungsten.svg').default,
  ['icon_footer_more.svg']: require('./icon_footer_more.svg').default,
  ['icon_footer_play.svg']: require('./icon_footer_play.svg').default,
  ['icon_footer_play_tungsten.svg']: require('./icon_footer_play_tungsten.svg').default,
  ['icon_footer_store.svg']: require('./icon_footer_store.svg').default,
  ['icon_footer_store_tungsten.svg']: require('./icon_footer_store_tungsten.svg').default,
  ['icon_hamburger_chat.svg']: require('./icon_hamburger_chat.svg').default,
  ['icon_hamburger_freebonuscash.svg']: require('./icon_hamburger_freebonuscash.svg').default,
  ['icon_hamburger_helpcenter.svg']: require('./icon_hamburger_helpcenter.svg').default,
  ['icon_header_chat.svg']: require('./icon_header_chat.svg').default,
  ['icon_header_z.svg']: require('./icon_header_z.svg').default,
  ['icon_i.svg']: require('./icon_i.svg').default,
  ['icon_info_filled.svg']: require('./icon_info_filled.svg').default,
  ['icon_info_i.svg']: require('./icon_info_i.svg').default,
  ['icon_info_outline.svg']: require('./icon_info_outline.svg').default,
  ['icon_left_arrow.svg']: require('./icon_left_arrow.svg').default,
  ['icon_loader.svg']: require('./icon_loader.svg').default,
  ['icon_lock.svg']: require('./icon_lock.svg').default,
  ['icon_more_bonus.svg']: require('./icon_more_bonus.svg').default,
  ['icon_more_chat.svg']: require('./icon_more_chat.svg').default,
  ['icon_more_contact.svg']: require('./icon_more_contact.svg').default,
  ['icon_more_news.svg']: require('./icon_more_news.svg').default,
  ['icon_more_support.svg']: require('./icon_more_support.svg').default,
  ['icon_more_treasure.svg']: require('./icon_more_treasure.svg').default,
  ['icon_more_trophies.svg']: require('./icon_more_trophies.svg').default,
  ['icon_navigation_close.svg']: require('./icon_navigation_close.svg').default,
  ['icon_navigation_left_small.svg']: require('./icon_navigation_left_small.svg').default,
  ['icon_notification_bell.svg']: require('./icon_notification_bell.svg').default,
  ['icon_people.svg']: require('./icon_people.svg').default,
  ['icon_percentage.svg']: require('./icon_percentage.svg').default,
  ['icon_play_brackets.svg']: require('./icon_play_brackets.svg').default,
  ['icon_play_brackets_v2.svg']: require('./icon_play_brackets_v2.svg').default,
  ['icon_play_button_instamatch.svg']: require('./icon_play_button_instamatch.svg').default,
  ['icon_play_events.svg']: require('./icon_play_events.svg').default,
  ['icon_play_events_v2.svg']: require('./icon_play_events_v2.svg').default,
  ['icon_play_friends.svg']: require('./icon_play_friends.svg').default,
  ['icon_play_headtohead.svg']: require('./icon_play_headtohead.svg').default,
  ['icon_play_headtohead_v2.svg']: require('./icon_play_headtohead_v2.svg').default,
  ['icon_play_live.svg']: require('./icon_play_live.svg').default,
  ['icon_play_live_v2.svg']: require('./icon_play_live_v2.svg').default,
  ['icon_play_practice.svg']: require('./icon_play_practice.svg').default,
  ['icon_play_practive_v2.svg']: require('./icon_play_practive_v2.svg').default,
  ['icon_play_recommended.svg']: require('./icon_play_recommended.svg').default,
  ['icon_play_tungsten_brackets.svg']: require('./icon_play_tungsten_brackets.svg').default,
  ['icon_play_tungsten_events.svg']: require('./icon_play_tungsten_events.svg').default,
  ['icon_play_tungsten_friends.svg']: require('./icon_play_tungsten_friends.svg').default,
  ['icon_play_tungsten_headtohead.svg']: require('./icon_play_tungsten_headtohead.svg').default,
  ['icon_play_tungsten_live.svg']: require('./icon_play_tungsten_live.svg').default,
  ['icon_play_tungsten_yourturn.svg']: require('./icon_play_tungsten_yourturn.svg').default,
  ['icon_play_view_less.svg']: require('./icon_play_view_less.svg').default,
  ['icon_play_view_more.svg']: require('./icon_play_view_more.svg').default,
  ['icon_player_crown.svg']: require('./icon_player_crown.svg').default,
  ['icon_recurring_trophies_timer.svg']: require('./icon_recurring_trophies_timer.svg').default,
  ['icon_referral_gift.svg']: require('./icon_referral_gift.svg').default,
  ['icon_replay.svg']: require('./icon_replay.svg').default,
  ['icon_reward_calendar_info_timer.svg']: require('./icon_reward_calendar_info_timer.svg').default,
  ['icon_right_arrow.svg']: require('./icon_right_arrow.svg').default,
  ['icon_search.svg']: require('./icon_search.svg').default,
  ['icon_share.svg']: require('./icon_share.svg').default,
  ['icon_share_android.svg']: require('./icon_share_android.svg').default,
  ['icon_shield.svg']: require('./icon_shield.svg').default,
  ['icon_shield_black.svg']: require('./icon_shield_black.svg').default,
  ['icon_shield_checkmark.svg']: require('./icon_shield_checkmark.svg').default,
  ['icon_shield_white.svg']: require('./icon_shield_white.svg').default,
  ['icon_shoutout_locked.svg']: require('./icon_shoutout_locked.svg').default,
  ['icon_shoutout_owned.svg']: require('./icon_shoutout_owned.svg').default,
  ['icon_skillz_rewardz.svg']: require('./icon_skillz_rewardz.svg').default,
  ['icon_stakes_selected_checkmark.svg']: require('./icon_stakes_selected_checkmark.svg').default,
  ['icon_store_calendar.svg']: require('./icon_store_calendar.svg').default,
  ['icon_store_promo_check.svg']: require('./icon_store_promo_check.svg').default,
  ['icon_store_promo_tag.svg']: require('./icon_store_promo_tag.svg').default,
  ['icon_store_v2_cash_icon.svg']: require('./icon_store_v2_cash_icon.svg').default,
  ['icon_store_v2_plus_final.svg']: require('./icon_store_v2_plus_final.svg').default,
  ['icon_store_v2_timer.svg']: require('./icon_store_v2_timer.svg').default,
  ['icon_store_v2_z_stretched.svg']: require('./icon_store_v2_z_stretched.svg').default,
  ['icon_template_sync.svg']: require('./icon_template_sync.svg').default,
  ['icon_ticketz.svg']: require('./icon_ticketz.svg').default,
  ['icon_timer_filled.svg']: require('./icon_timer_filled.svg').default,
  ['icon_waiting_spinner.svg']: require('./icon_waiting_spinner.svg').default,
  ['icon_warning_yellow.svg']: require('./icon_warning_yellow.svg').default,
  ['icon_withdrawal_instant_or_line.svg']: require('./icon_withdrawal_instant_or_line.svg').default,
  ['icon_withdrawal_option_fast_bank.svg']: require('./icon_withdrawal_option_fast_bank.svg').default,
  ['icon_withdrawal_option_instant_bank.svg']: require('./icon_withdrawal_option_instant_bank.svg').default,
  ['icon_withdrawal_option_original.svg']: require('./icon_withdrawal_option_original.svg').default,
  ['icon_x.svg']: require('./icon_x.svg').default,
  ['icon_x_close_18px.svg']: require('./icon_x_close_18px.svg').default,
  ['icon_x_gradient_background.svg']: require('./icon_x_gradient_background.svg').default,
  ['icon_x_no_padding.svg']: require('./icon_x_no_padding.svg').default,
  ['info.svg']: require('./info.svg').default,
  ['info_error.svg']: require('./info_error.svg').default,
  ['instamatch_prize_background_ribbon.svg']: require('./instamatch_prize_background_ribbon.svg').default,
  ['italic_info_brown.svg']: require('./italic_info_brown.svg').default,
  ['italic_info_gray.svg']: require('./italic_info_gray.svg').default,
  ['italic_info_icon_blue.svg']: require('./italic_info_icon_blue.svg').default,
  ['leftBlack.svg']: require('./leftBlack.svg').default,
  ['leftLine.svg']: require('./leftLine.svg').default,
  ['left_connector_horizontal.svg']: require('./left_connector_horizontal.svg').default,
  ['left_icon_arrow.svg']: require('./left_icon_arrow.svg').default,
  ['link_your_bank_now.svg']: require('./link_your_bank_now.svg').default,
  ['live_brackets_live_badge.svg']: require('./live_brackets_live_badge.svg').default,
  ['live_brackets_upcoming_badge.svg']: require('./live_brackets_upcoming_badge.svg').default,
  ['loser_left_new.svg']: require('./loser_left_new.svg').default,
  ['loser_right_new.svg']: require('./loser_right_new.svg').default,
  ['mail.svg']: require('./mail.svg').default,
  ['mail_white.svg']: require('./mail_white.svg').default,
  ['maintenance.svg']: require('./maintenance.svg').default,
  ['mask_fast_match_searching_screen.svg']: require('./mask_fast_match_searching_screen.svg').default,
  ['mergeArrow.svg']: require('./mergeArrow.svg').default,
  ['merge_account_icon.svg']: require('./merge_account_icon.svg').default,
  ['missed_frame.svg']: require('./missed_frame.svg').default,
  ['mobile.svg']: require('./mobile.svg').default,
  ['mobile_white.svg']: require('./mobile_white.svg').default,
  ['next_round_connector.svg']: require('./next_round_connector.svg').default,
  ['orange_crown.svg']: require('./orange_crown.svg').default,
  ['password_eye.svg']: require('./password_eye.svg').default,
  ['player_not_found.svg']: require('./player_not_found.svg').default,
  ['plus_icon.svg']: require('./plus_icon.svg').default,
  ['pointerHand.svg']: require('./pointerHand.svg').default,
  ['polygon.svg']: require('./polygon.svg').default,
  ['powered_by_aeropay.svg']: require('./powered_by_aeropay.svg').default,
  ['prize_model_agreement_icons.svg']: require('./prize_model_agreement_icons.svg').default,
  ['red_person.svg']: require('./red_person.svg').default,
  ['red_timer.svg']: require('./red_timer.svg').default,
  ['replay_dark.svg']: require('./replay_dark.svg').default,
  ['rewards.svg']: require('./rewards.svg').default,
  ['ribbon.svg']: require('./ribbon.svg').default,
  ['rightBlack.svg']: require('./rightBlack.svg').default,
  ['rightLine.svg']: require('./rightLine.svg').default,
  ['right_arrow_black.svg']: require('./right_arrow_black.svg').default,
  ['right_arrow_blue.svg']: require('./right_arrow_blue.svg').default,
  ['searching_bottom_banner.svg']: require('./searching_bottom_banner.svg').default,
  ['searching_top_banner.svg']: require('./searching_top_banner.svg').default,
  ['secured_by_aeropay.svg']: require('./secured_by_aeropay.svg').default,
  ['skillz_dark_theme_icon.svg']: require('./skillz_dark_theme_icon.svg').default,
  ['skillz_fairplay.svg']: require('./skillz_fairplay.svg').default,
  ['skillz_light_theme_icon.svg']: require('./skillz_light_theme_icon.svg').default,
  ['skillz_logo.svg']: require('./skillz_logo.svg').default,
  ['skillz_logo_black.svg']: require('./skillz_logo_black.svg').default,
  ['skillz_logo_gradient_whiteMark.svg']: require('./skillz_logo_gradient_whiteMark.svg').default,
  ['skillz_logo_wordmark_dark.svg']: require('./skillz_logo_wordmark_dark.svg').default,
  ['skillz_powered_logo.svg']: require('./skillz_powered_logo.svg').default,
  ['sparkle.svg']: require('./sparkle.svg').default,
  ['stay_secure.svg']: require('./stay_secure.svg').default,
  ['store_offer_bonus_tag_gold.svg']: require('./store_offer_bonus_tag_gold.svg').default,
  ['store_offer_bonus_tag_pink.svg']: require('./store_offer_bonus_tag_pink.svg').default,
  ['store_v2_supported_payments_final.svg']: require('./store_v2_supported_payments_final.svg').default,
  ['sync_opponent_ring.svg']: require('./sync_opponent_ring.svg').default,
  ['sync_player_ring.svg']: require('./sync_player_ring.svg').default,
  ['sync_user_rays.svg']: require('./sync_user_rays.svg').default,
  ['sync_vs.svg']: require('./sync_vs.svg').default,
  ['sync_vs_streaks.svg']: require('./sync_vs_streaks.svg').default,
  ['ticketz.svg']: require('./ticketz.svg').default,
  ['tournament_calendar.svg']: require('./tournament_calendar.svg').default,
  ['tournament_clock.svg']: require('./tournament_clock.svg').default,
  ['vs.svg']: require('./vs.svg').default,
  ['welcome_bonus.svg']: require('./welcome_bonus.svg').default,
  ['winner_left_new.svg']: require('./winner_left_new.svg').default,
  ['winner_right_new.svg']: require('./winner_right_new.svg').default,
  ['winner_single.svg']: require('./winner_single.svg').default,
  ['winningsSecured.svg']: require('./winningsSecured.svg').default,
  ['winningsSecuredRays.svg']: require('./winningsSecuredRays.svg').default,
  ['yellow_warning_icon.svg']: require('./yellow_warning_icon.svg').default,
};
